import { ApplicationRef, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MsalRedirectComponent } from "@azure/msal-angular";
import { EffectsModule } from "@ngrx/effects";
import {
  NavigationActionTiming,
  StoreRouterConnectingModule,
} from "@ngrx/router-store";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthModule } from "./modules/auth/auth.module";
import { HeroIconModule } from "./modules/icons/heroIcon.module"; // new ng-icons module
import { LocalStorageModule } from "./modules/local-storage/local-storage.module";
import { LoggingModule } from "./modules/logging/logging.module";
import { MaterialModule } from "./modules/material/material.module";
import { PersistentNotificationModule } from "./modules/persistent-notification/persistent-notification.module";
import { SideNavModule } from "./modules/side-nav/side-nav.module";
import { ThemeServiceModule } from "./modules/theme/theme.module";
import { UserShellModule } from "./modules/user/user-shell.module";
import { WorkspaceCoreModule } from "./modules/workspace/workspace-core.module";
import { WorkspaceShellModule } from "./modules/workspace/workspace-shell.module";
import { logProfile } from "./profilers/Profile.schema";
import { metaReducers, reducerProvider, REDUCERS_TOKEN } from "./reducers";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AuthModule,
    LoggingModule,
    HeroIconModule,
    MaterialModule,
    StoreModule.forRoot(REDUCERS_TOKEN, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    !environment.production
      ? StoreDevtoolsModule.instrument({ connectInZone: true })
      : [],
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot({
      navigationActionTiming: NavigationActionTiming.PostActivation,
    }),
    SideNavModule,
    UserShellModule,
    WorkspaceCoreModule,
    WorkspaceShellModule,
    LocalStorageModule,
    ThemeServiceModule,
    PersistentNotificationModule,
    FormsModule,
  ],
  providers: [reducerProvider],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {
  constructor(applicationRef: ApplicationRef) {
    // Profile change detection if not in production mode
    if (!environment.production) {
      const originalTick = applicationRef.tick;

      applicationRef.tick = function () {
        //if enableProfiling is not in localStorage then dont log profiling
        if (!localStorage.getItem("enableProfiling")) {
          return originalTick.apply(this);
        }
        const t0 = performance.now();
        const returnValue = originalTick.apply(this);
        const t1 = performance.now();

        // Log the timing information
        const delta = t1 - t0;
        logProfile("Change Detection", delta, 200);
        return returnValue;
      };
    }
  }
}
